import React, { PropsWithChildren } from 'react';

import './index.scss';

export interface QueryCardHeaderProps {
  label: string;
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
}

export default function QueryCardHeader({
  label, title, subtitle, action, children,
}: PropsWithChildren<QueryCardHeaderProps>) {
  return (
    <div className="query-card-header">
      <div className="query-card-header-top">
        <div className="query-card-header-main">
          <span className="query-card-header-label">{label}</span>
          {title && <span className="query-card-header-title">{title}</span>}
        </div>
        {action && <div className="query-card-header-action">{action}</div>}
      </div>
      {subtitle && <span className="query-card-header-subtitle">{subtitle}</span>}
      {children}
    </div>
  );
}
